import { render, staticRenderFns } from "./editAccountLimitation.vue?vue&type=template&id=2170ad2c"
import script from "./editAccountLimitation.vue?vue&type=script&lang=ts"
export * from "./editAccountLimitation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports